import { io } from "socket.io-client";
import { BASE_URL } from "../utils/endpoints";
import useAuthStore from "../store/authStore";

let socket = null;

export const initSocket = (sessionId) => {
  socket = io(BASE_URL, {
    query: { sessionId },
    transports: ["websocket"],
  });

  // console.log("✅ Socket initialized");

  socket.onAny((event, data) => {
    // console.log("🔔 Socket event triggered:", event, data);
  });

  socket.on("disconnect", () => {
    var userMeta = localStorage.getItem("userMeta");
    if (!userMeta) return;
    let sessionid = JSON.parse(userMeta).session_id;

    initSocket(sessionid);

    socket.connect();
  });

  useAuthStore.getState().setSocket(socket);

  return socket;
};

export const getSocket = () => socket;

export const disconnectSocket = () => {
  if (socket) socket.disconnect();
};
